export const credentials = {
	microsoftTeamsOAuth2Api: {
		scope: 'openid',
		oauthTokenData: {
			access_token: 'token',
		},
	},
};
